import { 
  applyMiddleware , 
  combineReducers , 
  compose         , 
  createStore
} from "redux";
import thunk from "redux-thunk";
import { userDataReducer } from "./reducers/userDataReducer" ;
import { chefAdminRecipeReducer } from "./reducers/chefAdminRecipeReducer";
import { chefAdminVideoReducer } from "./reducers/chefAdminVideoReducer";

const initialState = {
  userData: {
    paymentInfo: {
      clientSecret      : null  ,
      submittingPayment : false ,
      paymentMethodId   : null
    },
    loginInfo: {
      userCredits       : null,
      user_id           : null,
      uploadedFileIds   : []
    },
    chefProfileInfo: {
      email: null,
      username: null,
      instagramLink: null,
      youtubeLink: null,
      bioContent: null,
      chefProfileAvatar: null
    }
  },
  chefAdminRecipeData: {
    isLoading: false,
    successUpload: null,
    lastUploadedId: null,
    chefAdminRecipes: [],
    error: null
  },
  chefAdminVideoData: {
    isLoading: false,
    chefAdminVideos: [],
    error: null
  }
};

const reducers = combineReducers({
  userData              : userDataReducer     ,
  chefAdminRecipeData   : chefAdminRecipeReducer,
  chefAdminVideoData    : chefAdminVideoReducer
});

const composeEnhancer = (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({trace: true})) || compose;
const store = createStore(reducers, initialState, composeEnhancer(applyMiddleware(thunk)));

export default store;